<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
export default {
    page: {
        title: "Notifications",
    },
    components: {
        Layout,
        PageHeader,
    },
    data(){
        return {
            title: "Notifications",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Notifications",
                    active: true,
                },
            ],
            search: "",
        }
    },
    computed: {
        filtered(){
            return this.$store.state.notification.notifications.filter((x) => {
                return x.searchList.toLowerCase().includes(this.search.toLowerCase());
            });
        }
    },
    methods: {
        viewNotif(row) {
            this.$store.commit("notification/OPEN_OPTIONS", {row: row, showDeleteOption: false});
            this.$store
                .dispatch("notification/SeenNotif", row.id)
                .then((res) => {
                    this.$store.commit("notification/SEEN_STATUS", {row: row, status: "Seen"});
                });
        },
        deleteNotif(id) {
            this.$store.dispatch("notification/DeleteNotif", id).then((res) => {
                this.$store.commit("notification/REMOVE_NOTIFICATION", id);
            });
        },
        clearAllNotification() {
            Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#dc3545",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, clear it!",
            }).then((result) => {
                if (result.value) {
                    this.$store.dispatch("notification/DeleteAllNotif").then((res) => {
                        this.$store.commit("notification/SET_NOTIFICATIONS", []);
                    });
                }
            });
        },
    }
}
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" /> 
        <div class="d-flex align-items-center mb-2">
            <input type="text" class="form-control" placeholder="Search Notification..." v-model="search">
            <button type="button" class="btn btn-outline-danger text-nowrap ms-2" @click="clearAllNotification">Clear Notifications</button>
        </div>   
        <div class="card">
            <div class="card-body p-0">
                <div 
                    v-for="x in filtered"
                    :key="x.id"
                    class="text-reset notification-item position-relative w-100 border-bottom"
                >
                    <div
                        class="media"
                        :class="{
                            'bg-primary bg-soft':
                                x.status.toLowerCase() !== 'seen',
                        }"
                    >
                        <div class="avatar-xs me-3">
                            <span
                                class="
                                    avatar-title
                                    bg-primary
                                    rounded-circle
                                    font-size-16
                                "
                            >
                                <i class="bx bx-file"></i>
                            </span>
                        </div>
                        <div class="media-body">
                            <div class="d-flex align-items-center justify-content-between">
                                <h6
                                    class="
                                        mt-0
                                        mb-1
                                        cursor-pointer
                                        hoverable-link
                                    "
                                >
                                    {{ x.title }}
                                </h6>
                                <div class="d-flex align-items-center">
                                    <a href="javascript:void(0);" class="text-green" @click="viewNotif(x)" v-if="x.status.toLowerCase() !== 'seen'">Mark as read</a>
                                    <span v-if="x.status.toLowerCase() !== 'seen'" class="mx-2">|</span>
                                    <a href="javascript:void(0);" class="text-danger" @click="deleteNotif(x.id)">Remove</a>
                                </div>
                            </div>
                            <div class="font-size-12 text-muted">
                                <p class="mb-1 text-clamp">
                                    {{ x.description }}
                                </p>
                                <p class="mb-1">
                                    <i
                                        class="
                                            mdi mdi-clock-outline
                                        "
                                    ></i>
                                    {{ x.returnDate }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>